import { apiUrl } from './api';

async function customerRequest(path, { method = 'GET', body, token } = {}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(apiUrl(path), {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || `Request failed: ${response.status}`);
  }

  return payload;
}

export async function checkCustomerEmail(email) {
  return customerRequest('/auth/customer/check-email', {
    method: 'POST',
    body: { email },
  });
}

export async function syncCustomerProfile(token, profile = {}) {
  return customerRequest('/customers/sync', {
    method: 'POST',
    token,
    body: profile,
  });
}

export async function fetchCustomerProfile(token) {
  return customerRequest('/customers/me', { token });
}

export async function updateCustomerProfile(token, profile) {
  return customerRequest('/customers/me', {
    method: 'PUT',
    token,
    body: profile,
  });
}

export async function fetchCustomerOrders(token) {
  return customerRequest('/customers/me/orders', { token });
}
